import { render, staticRenderFns } from "./OpenTaskNotification.vue?vue&type=template&id=f799f4ec&scoped=true"
import script from "./OpenTaskNotification.vue?vue&type=script&lang=js"
export * from "./OpenTaskNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f799f4ec",
  null
  
)

export default component.exports